module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Website_Personalize_desktop@2x-1c3b789240db2a78301803b4d07e1b1f.webp";